import React from 'react';

/**
 * IaCPanel — shows Terraform HCL and TypeScript CDK side by side.
 *
 * Props:
 *   iacData  {object|null}  — { terraform_code, cdk_code }
 *
 * Only renders when iacData is not null.
 */
export default function IaCPanel({ iacData }) {
  if (!iacData) return null;

  return (
    <div className="card">
      <div className="iac-header">Cloud Infrastructure Scripts</div>
      <div className="iac-cols">
        {/* Terraform HCL */}
        <div className="iac-col">
          <div className="iac-col-header">🏗 Terraform (AWS Infrastructure)</div>
          <pre className="code-block">{iacData.terraform_code || '# generating…'}</pre>
        </div>

        {/* TypeScript CDK */}
        <div className="iac-col">
          <div className="iac-col-header">📦 AWS CDK (TypeScript)</div>
          <pre className="code-block">{iacData.cdk_code || '// generating…'}</pre>
        </div>
      </div>
    </div>
  );
}
